import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { intlShape } from 'react-intl'
import { Helmet } from 'react-helmet'
import classNames from 'classnames'

import { getFocus as getFocusAction } from './focusActions'
import Loader from '../../components/loader/Loader'
import redirectToApp from '../../utils/redirectToApp'
import { clearPlayqueue as clearPlayqueueAction } from '../../components/miniPlayer/AudioPlayer/playerActions'
import * as selectors from './focusSelectors'
import * as shapes from '../../constant/shapes'
import appConst from '../../constant/appConst'
import FocusAlbumCard from './FocusAlbumCard'
import * as playerSelectors from '../../components/miniPlayer/miniPlayerSelectors'
import * as constant from '../../components/miniPlayer/AudioPlayer/playerConstants'
import FocusAlbumBloc from './FocusAlbumBloc'

class FocusPage extends PureComponent {

	constructor(props) {
		super(props)
		this.state = {
			defaultCardHeight: null,
			defaultImageHeight: null
		}
		this.setCardsSizes = this.setCardsSizes.bind(this)
		this.onResize = this.onResize.bind(this)
	}

	componentWillMount() {
		const { id, getFocus } = this.props
		getFocus(id)
	}

	componentDidMount() {
		this.setCardsSizes()
		window.addEventListener('resize', this.onResize, false)
	}

	componentWillUnmount() {
		this.props.clearPlayqueue()
		window.removeEventListener('resize', this.onResize, false)
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.id !== nextProps.id) this.props.clearPlayqueue()
	}

	onResize() {
		this.setCardsSizes()
	}

	setCardsSizes() {
		const metaHeight = 54
		const albums = document.querySelectorAll('.albums-generic-grid-list > .item')
		if (albums) {
			const firstAlbum = albums[0]
			if (firstAlbum) {
				const cardWith = +firstAlbum.clientWidth
				this.setState({
					defaultImageHeight: cardWith - 2, // 1px border
					defaultCardHeight: cardWith + metaHeight
				})
			}
		}
	}

	render() {

		const { id, titleContainer, imageContainer, content, isCurrentTrack, isPlaying } = this.props
		const { intl } = this.context

		let shouldDisplayLettrine = true

		const shouldFadeOut = content && content.length && content[content.length - 1].type === appConst.focus.layout.text

		return (
			<Loader>
				<div className="content relative">
					<Helmet>
						<title>{intl.formatMessage({ id: 'title.focus' })}</title>
					</Helmet>
					<div className="focus-see-more">
						<a onClick={() => redirectToApp('focus', id)} className="bt7">
							{intl.formatMessage({ id: 'buttons.readfocus' })}
						</a>
					</div>
					<div className="container-fluid">
						{shouldFadeOut ? <div className="focus-gradient-overlay" /> : ''}
						<section>
							<div className="row focus">
								<div className="focus-background">
									{imageContainer && <img src={imageContainer.image} alt={imageContainer.credits} />}
									<h1 className="t4 text-center">{titleContainer.title}</h1>
									<p className="focus-from t2">
										<span className="c8">{intl.formatMessage({ id: 'focus.from' }, { author: titleContainer.author })}</span>
										<br />
										{titleContainer.date && <span className="t6 c9">
											{intl.formatDate(titleContainer.date, {
												day: 'numeric',
												month:'long',
												year:'numeric'
											})}
										</span>}
									</p>
								</div>
								<div className="col-md-12">
									<div className="text-center mb50">
										<a onClick={() => redirectToApp('focus', id)} className="bt7">
											{intl.formatMessage({ id: 'buttons.readfocus' })}
										</a>
									</div>
								</div>
								{titleContainer.accroche && <p className="focus-content t3 text-bold">
									<span dangerouslySetInnerHTML={{ __html: `${titleContainer.accroche}`.nl2br()}} />
								</p>}
								{content.map((container, key) => {
									switch (container.type) {
										case appConst.focus.layout.text:
											const classes = classNames('focus-content', {
												lettrine: shouldDisplayLettrine
											})
											shouldDisplayLettrine = false
											return (
												<p key={`focus-container-${key}`} className={classes}>
													<span
														dangerouslySetInnerHTML={{ __html: `${container.description}`.nl2br() }}
														className="focus-text"
													/>
												</p>
											)
										case appConst.focus.layout.carousel:
											let albumList = []
											if (container.albums && container.albums.items && container.albums.items.length) {
												albumList = container.albums.items.slice(0, container.number_col * container.number_raw)
											}
											return (
												<section key={`focus-container-${key}`} className="carousel-album">
													<p className="t1 text-center mb-10">
														{container.title} <span className="c2">{container.focus}</span>
													</p>
													{container.sub_title && <p className="c3 text-center mb30">{container.sub_title}</p>}
													<ul className={`focus-list col-${container.number_col}`}>
														{albumList.map((album, index) => <FocusAlbumCard
															forceCardHeight={this.state.defaultCardHeight}
															forceImageHeight={this.state.defaultImageHeight}
															key={`album-${index}`}
															current={isCurrentTrack(constant.ORIGIN_PLAYQUEUE_TYPES.album, album.id)}
															playing={isPlaying}
															album={album}
														/>)}
													</ul>
												</section>
											)
										case appConst.focus.layout.image:
											return (
												<section key={`focus-container-${key}`} className="focus-image">
													<div className="image-content">
														<img src={container.image} alt={container.credits} />
														<p className="text-center t3 c3">{container.credits}</p>
													</div>
												</section>
											)
										case appConst.focus.layout.quote:
											return (
												<section key={`focus-container-${key}`} className="focus-quote">
													<div className="quote-content">
														<p>{container.content}</p>
														<p className="quote-author">{container.title}</p>
													</div>
												</section>
											)
										case appConst.focus.layout.doubleImages:
											return (
												<ul key={`focus-container-${key}`} className="focus-picture">
													<li><img src={container.left_img} alt="" /></li>
													<li><img src={container.right_img} alt="" /></li>
												</ul>
											)
										case appConst.focus.layout.album:
											return (
												<section key={`focus-container-${key}`} className="focus-content focus-album">
													<FocusAlbumBloc
														album={container.album}
														current={isCurrentTrack(constant.ORIGIN_PLAYQUEUE_TYPES.album, container.album.id)}
														playing={isPlaying}
													/>
												</section>
											)
										case appConst.focus.layout.playlist:
										default:
											return null
									}
								})}
							</div>
						</section>
					</div>
				</div>
			</Loader>
		)
	}

}

FocusPage.propTypes = {
	id: PropTypes.string,
	content: PropTypes.arrayOf(shapes.focusContent),
	titleContainer: shapes.focusTitle,
	imageContainer: shapes.focusImage,
	isCurrentTrack: PropTypes.func,
	isPlaying: PropTypes.bool,
	getFocus: PropTypes.func,
	clearPlayqueue: PropTypes.func
}

FocusPage.contextTypes = {
	intl: intlShape
}

const mapStateToProps = (state, ownProps) => ({
	id: ownProps.params.id,
	titleContainer: selectors.getFocusTitle(state),
	imageContainer: selectors.getFocusImage(state),
	content: selectors.getFocusContent(state),
	isCurrentTrack: playerSelectors.isCurrentTrack(state),
	isPlaying: playerSelectors.isPlaying(state)
})

const actions = {
	getFocus: getFocusAction,
	clearPlayqueue: clearPlayqueueAction
}

export default connect(mapStateToProps, actions)(FocusPage)



// WEBPACK FOOTER //
// ./src/pages/focus/FocusPage.jsx